<template>
  <div class="image-slider">
    <transition name="grow">
      <div v-if="contentReady">
        <b-carousel v-if="!contentError" id="carouselHomepage"
        style="text-shadow: 1px 1px 2px #333;"
        controls
        indicators
        :interval="4000"
        >
          <a v-for="slide in sliders"
            v-bind:key="slide.id"
            :href="'/#' + slide.sliderlink[0]"
            v-if="slide.sliderlink.length > 0" >
              <b-carousel-slide
                :caption="slide.title.rendered"
                :text="slide.excerpt.rendered.replace(/<\/?[^>]+(>|$)/g, '')"
                :img-src="slide._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url">
              </b-carousel-slide>
          </a>
          <b-carousel-slide
            v-else
            :caption="slide.title.rendered"
            :text="slide.excerpt.rendered.replace(/<\/?[^>]+(>|$)/g, '')"
            :img-src="slide._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url">
          </b-carousel-slide>
        </b-carousel>
        <div v-if="contentError">
          {{sliderError}}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
export default {
  props: [
    'category'
  ],
  data () {
    return {
      sliders: [],
      sliderError: '',
      contentError: false,
      contentReady: false
    }
  },
  created () {
    WordpressRestAPI.getViewContent('image_slider?slider_category=' + this.category + '&_embed')
      .then(response => {
        this.sliders = response.data
        this.contentReady = true
      })
      .catch(e => {
        console.error(e)
        this.sliderError = 'Oops! We had a problem with loading the image slider.'
        this.contentError = true
      })
  }
}
</script>

<style lang="less">
  .image-slider {
    p {
      font-size: 1.2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ImageSlider.vue